var React = require('react');

function TickIconWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.1923 0.535534L4.24255 5.48528L2.12123 3.36396C1.7307 2.97344 1.09754 2.97344 0.707015 3.36396C0.316491 3.75448 0.316491 4.38765 0.707015 4.77817L2.82834 6.89949L4.24255 8.31371L5.65676 6.89949L10.6065 1.94975C10.997 1.55922 10.997 0.926058 10.6065 0.535534C10.216 0.145009 9.58282 0.14501 9.1923 0.535534Z","fill":"#FFFBE7"}));
}

TickIconWhite.defaultProps = {"width":"11","height":"9","viewBox":"0 0 11 9","fill":"none"};

module.exports = TickIconWhite;

TickIconWhite.default = TickIconWhite;
